//import { alpha } from '@mui/material/styles';


import { styled, alpha } from '@mui/system';
import {Toolbar, Typography, InputBase, Box} from '@mui/material';

// Exclamation mark button styles for inline placement next to flags - white/transparent design
export const ExclaimButtonStyles = {
  backgroundColor: 'rgba(255, 255, 255, 0.9)', // White transparent background
  color: '#333',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 1)' // Solid white on hover
  },
  borderRadius: '50%',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  width: 36,
  height: 36,
  marginLeft: '8px', // spacing from Chinese flag
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none'
};



export const MyToolBar = styled(Toolbar)(({ theme }) => ({
    display: 'flex', justifyContent: 'space-between',
  }));

export const MyTypography = styled(Typography)(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
     }
  }));

/*  
export const SearchStyledDiv = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': { backgroundColor: alpha(theme.palette.common.white, 0.25) },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',  
    [theme.breakpoints.up('sm')]: { marginLeft: theme.spacing(3), width: 'auto' },
  }));
*/
export const SearchStyledDiv = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': { backgroundColor: alpha(theme.palette.common.white, 0.25) },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.up('sm')]: { marginLeft: theme.spacing(3), width: 'auto' },
  }));
  export const SearchIconDiv = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2), height: '100%', position: 'absolute', pointerEvents: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center',
  }));


export  const MyInputBase = styled(InputBase)(({ theme }) => ({
    root: {
        color: 'inherit',
    },
    input: {
        padding: theme.spacing(1, 1, 1, 0), paddingLeft: `calc(1em + ${theme.spacing(4)}px)`, transition: theme.transitions.create('width'), width: '100%', [theme.breakpoints.up('md')]: { width: '20ch' },xShadow: `0 0 0 0.2rem ${theme.palette.primary.main}33`,
      },
    
  }));
/*

export default (theme) => ({
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': { backgroundColor: alpha(theme.palette.common.white, 0.25) },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: { marginLeft: theme.spacing(3), width: 'auto' },
  },
  searchIcon: {
    padding: theme.spacing(0, 2), height: '100%', position: 'absolute', pointerEvents: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0), paddingLeft: `calc(1em + ${theme.spacing(4)}px)`, transition: theme.transitions.create('width'), width: '100%', [theme.breakpoints.up('md')]: { width: '20ch' },
  },
  toolbar: {
    display: 'flex', justifyContent: 'space-between',
  },
})
*/